import React, { useContext } from 'react';
import './menu.css';
import { useTranslation } from 'react-i18next';
import { NavLink, useHistory, useLocation } from "react-router-dom";

import AuthContext from '../../context/Auth/AuthContext';

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { FiLogOut, FiUser } from 'react-icons/fi'
import { MdLanguage } from "react-icons/md";
import { DiAptana } from "react-icons/di";

function Menu() {

    const { t, i18n } = useTranslation('common');
    const { user, logout, is_login, is_selected_institution, is_firstime, get_currentInstitution } = useContext(AuthContext);
    const history = useHistory();
    const { pathname } = useLocation();    

    const signout = () => {
        logout(() => {
            history.replace({ from: { pathname: "/Login" } });
        });
    };


    //The title is solved using the path, only some of them have this feature.
    let no_menu_title = ''
    switch (pathname) {
        case '/Login':
            no_menu_title = t('login.title')
            break;
        case '/ForgotPassword':
            no_menu_title = t('forgotPassword.menu_title');
            break;
        case '/ChangePassword':
            no_menu_title = t('changePassword.title');
            break;
        case '/AuthInstitutions':
            no_menu_title = 'Auth Institutions'
            break;
        case '/FirstTime':
            no_menu_title = t('changePassword.tilte_firstTime');
            break;
        case '/ExtAuth':
            no_menu_title = 'External Auth';
            break;

        default:
            no_menu_title = ''
            break;
    }

    //Asked whether to display a title or menu options
    const menuOptions = (
        is_login() && is_selected_institution() && pathname !== '/AuthInstitutions' ? (
            <>
                <li className="nav-item active">
                    <NavLink to="/" className="nav-link link_Menu" activeClassName="link_Menu_active" exact>{t('menu.home')}</NavLink>
                </li>
                <li className="nav-item dropdown">
                    <div className="nav-link dropdown-toggle link_Menu" id="configurationDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {t('menu.configuration')}
                    </div>
                    <div className="dropdown-menu dropdown_general" aria-labelledby="configurationDropdown">
                        {
                            get_currentInstitution().currentModuleRoleCode === 'ADM' ?
                                <>
                                    <NavLink to="/SpFunctions" className="nav-link link_Menu" activeClassName="link_Menu_active">{t('menu.spFunctions')}</NavLink>
                                    <NavLink to="/SpComponents" className="nav-link link_Menu" activeClassName="link_Menu_active">{t('menu.spComponents')}</NavLink>
                                </> : null
                        }

                        <NavLink to="/PopGroups" className="nav-link link_Menu" activeClassName="link_Menu_active">{t('menu.spPopGroups')}</NavLink>
                        <NavLink to="/Benefits" className="nav-link link_Menu" activeClassName="link_Menu_active">{t('menu.benefits')}</NavLink>
                    </div>
                </li>
                <li className="nav-item active">
                    <NavLink to="/Models" className="nav-link link_Menu" activeClassName="link_Menu_active">{t('menu.models')}</NavLink>
                </li>
                <li className="nav-item active">
                    <NavLink to="/Scenarios" className="nav-link link_Menu" activeClassName="link_Menu_active">{t('menu.scenarios')}</NavLink>
                </li>
                {
                    get_currentInstitution().currentModuleRoleCode === 'ADM' ?
                        <>
                            <li className="nav-item active">
                                <NavLink to="/Log" className="nav-link link_Menu" activeClassName="link_Menu_active">{t('menu.log')}</NavLink>
                            </li>
                        </> : null
                }

            </>
        ) : (
            <li className="nav-item active">
                <p className='m-0 no_menu_title'>{no_menu_title}</p>
            </li>
        )
    )

    return (
        <nav className="navbar navbar-expand-lg navbar-light navbar_prop_styles" style={{ backgroundColor: "#230050", color: "#FFFFFF", padding: "0 0.5em 0 0", marginLeft: "-15px", marginRight: "-15px" }}>
            <button className="navbar-toggler toggler_custom" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                {/*Parte izquierda del menú: por eso se usa la clase mr-auto*/}
                <ul className="navbar-nav mr-auto">
                    {menuOptions}
                </ul>
                {/*Parte derecha del menú: por eso se usa la clase ml-auto*/}
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item dropdown">
                        <div className="nav-link dropdown-toggle link_Menu mr-2" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <MdLanguage className="icon_language" /> {t('menu.lan')}
                        </div>
                        <div className="dropdown-menu dropdown_general dropdown_languages" aria-labelledby="navbarDropdown">
                            <button className="dropdown-item dropdown_text" onClick={() => i18n.changeLanguage('en')}>{t('menu.enLbl')}</button>
                            <button className="dropdown-item dropdown_text" onClick={() => i18n.changeLanguage('es')}>{t('menu.esLbl')}</button>
                            <button className="dropdown-item dropdown_text" onClick={() => i18n.changeLanguage('fr')}>{t('menu.frLbl')}</button>
                        </div>
                    </li>
                    {is_login() ? (
                        <>
                            <li className="nav-item active">
                                <NavLink to="/ChangePassword" className="nav-link link_Menu" activeClassName="link_Menu_active">
                                    <DiAptana /> {t('menu.changePassword')}
                                </NavLink>                                
                            </li>
                            <li className="nav-item active user_labl">
                                <div className="nav-link link_Menu"> <FiUser /> {user ? user.email : ''}</div>
                            </li>
                            {!is_firstime() &&
                                <li className="nav-item active">
                                    <div onClick={signout} className="nav-link link_Menu"> <FiLogOut /> {t('menu.logOut')}</div>
                                </li>
                            }
                        </>) : null}

                </ul>
            </div >
        </nav >
    );

}

export default Menu